import React, { useState, useEffect } from 'react';
import './VideoBackground.css';
import { isNo2HarmDomain } from '../utils/assetLoader';

// Import common video files as fallbacks
// import fallbackVideo from '../assets/videos/cope-2025-02.mp4';

// Import StopVio video files dynamically to handle possible missing files
const stopvioHeaderVideo1 = require('../assets/videos/stopvio/cope-2025-04.mp4');
const stopvioHeaderVideo2 = require('../assets/videos/stopvio/cope-2025-06.mp4');
const stopvioBodyVideo1 = require('../assets/videos/stopvio/cope-2025-02.mp4');

// Import No2Harm video files dynamically to handle possible missing files
const no2harmHeaderVideo1 = require('../assets/videos/no2harm/cope-2025-04.mp4');
const no2harmHeaderVideo2 = require('../assets/videos/no2harm/cope-2025-06.mp4');
const no2harmBodyVideo1 = require('../assets/videos/no2harm/cope-2025-02.mp4');
/**
 * VideoBackground component that displays videos with low opacity in the background
 * @param {Object} props - Component props
 * @param {string} props.placement - Where to place the video ('header' or 'body')
 */
function VideoBackground({ placement = 'body' }) {
  const [currentVideo, setCurrentVideo] = useState(0);

  // Check if we're on the no2harm.com domain
  const isNo2Harm = isNo2HarmDomain();
     
  // Define video arrays based on domain and placement
  const headerVideos = isNo2Harm 
    ? [no2harmHeaderVideo1, no2harmHeaderVideo2]
    : [stopvioHeaderVideo1, stopvioHeaderVideo2];
    
  const bodyVideos = isNo2Harm
    ? [no2harmBodyVideo1]
    : [stopvioBodyVideo1];
  
  // Choose the appropriate video list based on placement
  const videos = placement === 'header' ? headerVideos : bodyVideos;

  const handleVideoEnd = () => {
    setCurrentVideo((prev) => (prev + 1) % videos.length);
  };

  useEffect(() => {
    const videoElement = document.getElementById(`video-background-${placement}`);

    if (videoElement) {
      videoElement.play().catch(err => {
        console.warn('Auto-play was prevented:', err);
      });
    }
  }, [currentVideo, placement]);

  return (
    <div className="video-container">
      <video
        id={`video-background-${placement}`}
        className="video-background"
        src={videos[currentVideo]}
        autoPlay
        muted
        onEnded={handleVideoEnd}
        playsInline
      />
    </div>
  );
}

export default VideoBackground;
